import Image from "next/image";
import styles from "./DreamforceMeetingModal.module.css";

interface Props {
  show: boolean;
  handleClose: () => void;
  ctaHref?: string;
}

const CalendarIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.3333 4.7465V2.6665C22.3333 2.11984 21.88 1.6665 21.3333 1.6665C20.7866 1.6665 20.3333 2.11984 20.3333 2.6665V4.6665H11.6666V2.6665C11.6666 2.11984 11.2133 1.6665 10.6666 1.6665C10.12 1.6665 9.66665 2.11984 9.66665 2.6665V4.7465C6.06665 5.07984 4.31998 7.2265 4.05331 10.4132C4.02665 10.7998 4.34665 11.1198 4.71998 11.1198H27.28C27.6666 11.1198 27.9866 10.7865 27.9466 10.4132C27.68 7.2265 25.9333 5.07984 22.3333 4.7465Z"
      fill="#8ABC00"
    />
    <path
      d="M26.6667 13.1201H5.33333C4.6 13.1201 4 13.7201 4 14.4535V22.6668C4 26.6668 6 29.3335 10.6667 29.3335H21.3333C26 29.3335 28 26.6668 28 22.6668V14.4535C28 13.7201 27.4 13.1201 26.6667 13.1201ZM12.28 24.2801C12.2133 24.3334 12.1467 24.4001 12.08 24.4401C12 24.4935 11.92 24.5335 11.84 24.5601C11.76 24.6001 11.68 24.6268 11.6 24.6401C11.5067 24.6535 11.4267 24.6668 11.3333 24.6668C11.16 24.6668 10.9867 24.6268 10.8267 24.5601C10.6533 24.4935 10.52 24.4001 10.3867 24.2801C10.1467 24.0268 10 23.6801 10 23.3335C10 22.9868 10.1467 22.6401 10.3867 22.3868C10.52 22.2668 10.6533 22.1735 10.8267 22.1068C11.0667 22.0001 11.3333 21.9735 11.6 22.0268C11.68 22.0401 11.76 22.0668 11.84 22.1068C11.92 22.1335 12 22.1735 12.08 22.2268C12.1467 22.2801 12.2133 22.3335 12.28 22.3868C12.52 22.6401 12.6667 22.9868 12.6667 23.3335C12.6667 23.6801 12.52 24.0268 12.28 24.2801ZM12.28 19.6135C12.0267 19.8535 11.68 20.0001 11.3333 20.0001C10.9867 20.0001 10.64 19.8535 10.3867 19.6135C10.1467 19.3601 10 19.0135 10 18.6668C10 18.3201 10.1467 17.9735 10.3867 17.7201C10.76 17.3468 11.3467 17.2268 11.84 17.4401C12.0133 17.5068 12.16 17.6001 12.28 17.7201C12.52 17.9735 12.6667 18.3201 12.6667 18.6668C12.6667 19.0135 12.52 19.3601 12.28 19.6135ZM16.9467 24.2801C16.6933 24.5201 16.3467 24.6668 16 24.6668C15.6533 24.6668 15.3067 24.5201 15.0533 24.2801C14.8133 24.0268 14.6667 23.6801 14.6667 23.3335C14.6667 22.9868 14.8133 22.6401 15.0533 22.3868C15.5467 21.8935 16.4533 21.8935 16.9467 22.3868C17.1867 22.6401 17.3333 22.9868 17.3333 23.3335C17.3333 23.6801 17.1867 24.0268 16.9467 24.2801ZM16.9467 19.6135C16.88 19.6668 16.8133 19.7201 16.7467 19.7735C16.6667 19.8268 16.5867 19.8668 16.5067 19.8935C16.4267 19.9335 16.3467 19.9601 16.2667 19.9734C16.1733 19.9868 16.0933 20.0001 16 20.0001C15.6533 20.0001 15.3067 19.8535 15.0533 19.6135C14.8133 19.3601 14.6667 19.0135 14.6667 18.6668C14.6667 18.3201 14.8133 17.9735 15.0533 17.7201C15.1733 17.6001 15.32 17.5068 15.4933 17.4401C15.9867 17.2268 16.5733 17.3468 16.9467 17.7201C17.1867 17.9735 17.3333 18.3201 17.3333 18.6668C17.3333 19.0135 17.1867 19.3601 16.9467 19.6135ZM21.6133 24.2801C21.36 24.5201 21.0133 24.6668 20.6667 24.6668C20.32 24.6668 19.9733 24.5201 19.72 24.2801C19.48 24.0268 19.3333 23.6801 19.3333 23.3335C19.3333 22.9868 19.48 22.6401 19.72 22.3868C20.2133 21.8935 21.12 21.8935 21.6133 22.3868C21.8533 22.6401 22 22.9868 22 23.3335C22 23.6801 21.8533 24.0268 21.6133 24.2801ZM21.6133 19.6135C21.5467 19.6668 21.48 19.7201 21.4133 19.7735C21.3333 19.8268 21.2533 19.8668 21.1733 19.8935C21.0933 19.9335 21.0133 19.9601 20.9333 19.9734C20.84 19.9868 20.7467 20.0001 20.6667 20.0001C20.32 20.0001 19.9733 19.8535 19.72 19.6135C19.48 19.3601 19.3333 19.0135 19.3333 18.6668C19.3333 18.3201 19.48 17.9735 19.72 17.7201C19.8533 17.6001 19.9867 17.5068 20.16 17.4401C20.4 17.3335 20.6667 17.3068 20.9333 17.3601C21.0133 17.3735 21.0933 17.4001 21.1733 17.4401C21.2533 17.4668 21.3333 17.5068 21.4133 17.5601C21.48 17.6135 21.5467 17.6668 21.6133 17.7201C21.8533 17.9735 22 18.3201 22 18.6668C22 19.0135 21.8533 19.3601 21.6133 19.6135Z"
      fill="#8ABC00"
    />
  </svg>
);

const PinIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.4935 11.2668C26.0935 5.10683 20.7201 2.3335 16.0001 2.3335C16.0001 2.3335 16.0001 2.3335 15.9868 2.3335C11.2801 2.3335 5.89346 5.0935 4.49346 11.2535C2.93346 18.1335 7.14679 23.9602 10.9601 27.6268C12.3735 28.9868 14.1868 29.6668 16.0001 29.6668C17.8135 29.6668 19.6268 28.9868 21.0268 27.6268C24.8401 23.9602 29.0535 18.1468 27.4935 11.2668ZM16.0001 17.9468C13.6801 17.9468 11.8001 16.0668 11.8001 13.7468C11.8001 11.4268 13.6801 9.54683 16.0001 9.54683C18.3201 9.54683 20.2001 11.4268 20.2001 13.7468C20.2001 16.0668 18.3201 17.9468 16.0001 17.9468Z"
      fill="#0086E6"
    />
  </svg>
);

const ShieldCheckIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.6">
      <path
        d="M10.4902 2.23006L5.50016 4.11006C4.35016 4.54006 3.41016 5.90006 3.41016 7.12006V14.5501C3.41016 15.7301 4.19016 17.2801 5.14016 17.9901L9.44016 21.2001C10.8502 22.2601 13.1702 22.2601 14.5802 21.2001L18.8802 17.9901C19.8302 17.2801 20.6102 15.7301 20.6102 14.5501V7.12006C20.6102 5.89006 19.6702 4.53006 18.5202 4.10006L13.5302 2.23006C12.6802 1.92006 11.3202 1.92006 10.4902 2.23006Z"
        stroke="#040405"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.05078 11.8697L10.6608 13.4797L14.9608 9.17969"
        stroke="#040405"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

const DreamforceMeetingModal: React.FC<Props> = ({
  show,
  handleClose,
  ctaHref = "https://meetings-na2.hubspot.com/deep-karia?uuid=319f0fa7-8a1a-4c94-8f93-f861c9018379",
}) => {
  if (!show) return null;

  return (
    <section
      className={styles.popupBackdrop}
      aria-label="Dreamforce meeting invitation"
    >
      <article className={styles.dreamforceCard}>
        <div className={styles.cardContent}>
          <div className={styles.brandRow}>
            <Image
              className={styles.dreamforceLogo}
              src="/images/dreamforce/dreamforce-logo.png"
              alt="Dreamforce"
              width={171}
              height={45}
            />
            <span className={styles.logoDivider} aria-hidden="true" />
            <Image
              className={styles.trootechLogo}
              src="/images/dreamforce/trootech-logo.png"
              alt="TRooTech"
              width={134}
              height={40}
            />
          </div>

          <div className={styles.copy}>
            <h1 className={styles.title}>MEET US AT</h1>
            <h2 className={styles.subtitle}>
              <span>DREAMFORCE 2026</span>
            </h2>

            <p className={styles.description}>
              TRooTech team is available for a meeting in San Francisco, from{" "}
              <b>Sept. 12th-27th.</b>
            </p>

            <div className={styles.details}>
              <div className={styles.detail}>
                <span className={`${styles.icon} ${styles.calendar}`}>
                  <CalendarIcon />
                </span>
                <div>
                  <small className={styles.detailLabel}>Event date</small>
                  <b className={styles.detailValue}>Sept.15th-17th</b>
                </div>
              </div>

              <div className={styles.detail}>
                <span className={`${styles.icon} ${styles.pin}`}>
                  <PinIcon />
                </span>
                <div>
                  <small className={styles.detailLabel}>San Francisco</small>
                  <b className={styles.detailValue}>California, USA</b>
                </div>
              </div>
            </div>

            <a className={styles.cta} href={ctaHref}>
              <span className={styles.ctaLabel}>Book Your Meeting With Us</span>
              <span className={styles.arrow}>&#8250;</span>
            </a>

            <div className={styles.partner}>
              <span className={styles.shield}>
                <ShieldCheckIcon />
              </span>
              <span>Trusted Salesforce Partner</span>
            </div>
          </div>
        </div>

        <div className={styles.cardVisual}>
          <div className={styles.visualLabels}>
            <div>
              CONNECT <i className={styles.dot} />
            </div>
            <div>
              INNOVATE <i className={`${styles.dot} ${styles.dotGreen}`} />
            </div>
            <div>
              TRANSFORM <i className={styles.dot} />
            </div>
          </div>
          <Image
            className={styles.robot}
            src="/images/dreamforce/robot.png"
            alt=""
            width={303}
            height={274}
          />
        </div>
        <button
          className={styles.closeButton}
          type="button"
          aria-label="Close"
          onClick={handleClose}
        >
          &times;
        </button>
      </article>
    </section>
  );
};

export default DreamforceMeetingModal;
